import { generateAuthHeader } from "../../../commonfunctions/authentication";
import { IAddItemsResponse } from "../types";

const addItems = async (fetchedProducts: any): Promise<IAddItemsResponse> => {
  const url = `${process.env.REACT_APP_HALFBACK_ROOT_API}/bulk_orders/add_items/`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...generateAuthHeader().headers,
      },
      body: JSON.stringify({
        items: fetchedProducts,
      }),
    });

    const data = await response.json();

    if (data.result === "failed") {
      return {
        status: 400,
        message: data.message,
        code: "failed_result",
      };
    }
    // SUCCESS
    return {
      status: 200,
      message: "ok",
      code: "success",
    };
  } catch (error) {
    return {
      status: 400,
      message: "Order upload failed at adding items to cart",
      code: "failed_result",
    };
  }
};

export default addItems;
